export default __webpack_public_path__ + "static/media/2627 cutlery top.7a8e1a9d.png";